import React from 'react'
import 'rc-slider/assets/index.css'
// import 'rc-tooltip/assets/bootstrap.css'
import Slider from 'rc-slider'
import Tooltip from 'rc-tooltip'
import chroma from 'chroma-js'

import './styles.scss'

// const SliderWithTooltip = createSliderWithTooltip(Slider)
const Handle = Slider.Handle

const handle = props => {
  const { value, dragging, index, ...restProps } = props

  return (
    <Tooltip
      className='tooltip-custom'
      prefixCls='rc-slider-tooltip'
      overlay={value}
      visible={false}
      placement='top'
      key={index}
    >
      <Handle value={value} {...restProps} />
    </Tooltip>
  )
}

const SalarySlider = props => {
  // chroma scale Color
  const colorScale = chroma
    .scale(['#fee090', '#ea7f7f'])
    .mode('rgb')
    .domain([props.sliderValue + 1, 20000])

  const colorScaleTwo = chroma
    .scale(['#64b9e8', 'a6e8a6'])
    .mode('rgb')
    .domain([500, props.sliderValue])

  const sliderPosition = (props.sliderValue * 100) / 20000

  return (
    <div className='sliderContainer'>
      <Slider
        min={500}
        step={50}
        max={20000}
        marks={{ 6502: 'Medianlohn Schweiz' }}
        handle={handle}
        onChange={props.onChange}
        onAfterChange={props.onAfterChange}
        defaultValue={6502}
        railStyle={{
          background: `linear-gradient(90deg,  ${colorScale(
            props.sliderValue
          )} ${sliderPosition + '%'}, ${colorScale(20000)} 100%`
        }}
        trackStyle={{
          background: `linear-gradient(90deg, ${colorScaleTwo(
            500
          )} 0%, ${colorScaleTwo(props.sliderValue)} ${100 + '%'}`
        }}
      />
    </div>
  )
}

export default SalarySlider
